module.exports = __webpack_public_path__ + "images/8a8b57df37095ed46788daac592872d4-LoginBrandImg.jpg";